export const config = {
    "theme": {
        "bs-primary-color": "#ee6f24",
        "bs-top-menu-primary-color": "#ee6f24",
        "bs-secondary-color": "#5c4b90",
        // other color #6e6e72
        "bs-text-primary-color": "#5c4b90",
        "bs-text-secondary-color": "#5c5c5c",
        "bs-text-white": "#fff",
        "bs-text-mandatory": "#ff0000",
        "bs-breadcrumb-color": "#ededed",
        "bs-active-breadcrumb-color": "#000000",
        "bs-disabled-color": "#ededed",
        "bs-border-color": "#ededed",
        "bs-hr": "#ededed",
        "bs-table-border": "#ededed",
        "bs-table-header": "#d7e7ea",
        "bs-table-row": "#f2f2f2",
        "bs-table-row-list": "#212529",
        "bs-toast-header": "#d7e7ea",
        "bs-theme-background-color": "#5c4b90"
    },
    "logo": {
        "loader": "assets/images/logo/veridy/veridyLoader.jpg",
        "main": "assets/images/logo/veridy/veridyMain.jpg",
        "favicon": "assets/images/favicon/veridy/favicon.ico",
        "banner": "assets/images/banners/veridy/banner.jpg",
        "loginBanner": "assets/images/background/veridy/veridy-bg-image.jpg"
    },
    "contact": {
        "copyright": "Copyright@2023 Veridy Health. All Rights Reserved.",
        "phone": "+1 888-375-4440",
        "servicePhone": "+1 888-375-4440",
        "salesPhone": "+1 888-375-4440",
        "fax": "+1 401-633-6598",
        "email": "info@ienrollsolutions.com",
        "serviceEmail": "service@ienrollsolutions.com",
        "salesEmail": "sales@ienrollsolutions.com",
        "address": {
            "lineOne": "200 Midway Road,",
            "lineTwo": "PO Box 8493 Cranston,",
            "lineThree": "RI 02920"
        }
    },
    "configuration": {
        "siteTitle": "Veridy Health",
        "header": true,
        "footer": false,
        "privacyLink": true,
        "termsLink": true,
        "maintenance": false
    }
};